import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { GENERAL_IMAGE_PLACEHOLDER } from '../../../../constants/app.constant';
import { getLongLanguageOptions, Language } from '../../../../constants/ui-utils.constant';
import { LanguageLocal, UiProgramType } from '../../../../enum/ui-utils.enum';
import { CourseListingDetailModel } from '../../../../models/webinar-course.model';
import { FavoritesSyncService } from '../../../../services/favorites-sync.service';
import { StorageService } from '../../../../services/storage.service';

@Component({
    selector: 'app-course-card',
    templateUrl: './course-card.component.html',
    styleUrls: ['../program-card/program-card.component.scss'],
})
export class CourseCardComponent implements OnInit, OnDestroy {
    @Input() courseListing: CourseListingDetailModel = {} as CourseListingDetailModel;
    @Input() isCompleted: boolean = false;
    @Input() isHorizontalLayout: boolean = false;

    topicUi: string = '';
    categories = '';
    
    private favoritesSyncSubscription: Subscription = new Subscription();

    UiProgramType = UiProgramType;

    GENERAL_IMAGE_PLACEHOLDER = GENERAL_IMAGE_PLACEHOLDER;

    getLongLanguageOptions = getLongLanguageOptions;

    constructor(
        private storageService: StorageService,
        private favoritesSyncService: FavoritesSyncService
    ) {}

    ngOnInit(): void {
        this.getTopicUi();
        this.subscribeToFavoriteChanges();
    }

    ngOnDestroy(): void {
        this.favoritesSyncSubscription.unsubscribe();
    }

    protected updateBookmarkUi(): void {
        this.courseListing.isFavorite = !this.courseListing.isFavorite;
    }

    private subscribeToFavoriteChanges(): void {
        this.favoritesSyncSubscription = this.favoritesSyncService.favoriteChange$.subscribe(
            (favoriteChange) => {
                // Update favorite status if this card matches the changed program ID
                if (this.courseListing.id === favoriteChange.programId) {
                    this.courseListing.isFavorite = favoriteChange.isFavorite;
                }
            }
        );
    }

    private getTopicUi(): void {
        if (this.courseListing.category) {
            this.topicUi = this.courseListing.category[0];

            if (this.storageService.language === LanguageLocal.LanguageCN) {
                const translation = this.courseListing.categoryTranslations?.find((t) => t.language === Language.CH);

                this.categories = translation?.description?.join(', ') || this.courseListing.category.join(', ');
            }
            else {
                this.categories = this.courseListing.category.join(', ');
            }
        }
    }
}
